import { render } from "./SearchUser.vue?vue&type=template&id=7e37d990&ts=true"
import script from "./SearchUser.vue?vue&type=script&lang=ts"
export * from "./SearchUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__